import React, { FC, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import Tooltip from '../common/Tooltip'
import { CircleHelp } from 'lucide-react'

interface LabelProps {
    htmlFor?: string
    children: ReactNode
    className?: string
    required?: boolean
    help?: string
}

const Label: FC<LabelProps> = ({ htmlFor, children, required, help, className }) => {
    return (
        <label
            htmlFor={htmlFor}
            className={twMerge(
                // Default classes that apply by default
                'mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400',

                // User-defined className that can override the default margin
                className
            )}
        >
            <div className='flex items-center gap-1'>
                {children}
                {required && <span className='text-error-500'>*</span>}
                {help && (
                    <>
                        <Tooltip label={help}>
                            <CircleHelp className='text-brand-500 h-5 w-5' />
                        </Tooltip>
                    </>
                )}
            </div>
        </label>
    )
}

export default Label
